module.exports = __webpack_public_path__ + "img/tap-menu-design3-min.daaeda5f.jpg";